import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import TikTokIcon from '../../common/TikTokIcon';

const PageInfoBar = ({ categories, redes }) => {
  const getSocialLink = (id, username) => {
    const valor = String(username || '').trim();
    if (!valor) return null;
    if (valor.startsWith('http')) return valor;

    // Remove @ if user included it
    const cleanUsername = valor.startsWith('@') ? valor.slice(1) : valor;

    const baseUrls = {
      instagram: 'https://instagram.com/',
      facebook: 'https://facebook.com/',
      tiktok: 'https://tiktok.com/@',
      youtube: 'https://youtube.com/@',
      x: 'https://x.com/',
      linkedin: 'https://linkedin.com/in/'
    };

    return baseUrls[id] ? `${baseUrls[id]}${cleanUsername}` : `https://${valor}`;
  };

  // Solo las que tiene la página: antes salían las seis y las que no tiene en gris claro, sin hacer nada
  const socialIcons = [
    { id: 'instagram', nombre: 'Instagram', icon: <InstagramIcon fontSize="small" />, link: getSocialLink('instagram', redes?.instagram) },
    { id: 'facebook', nombre: 'Facebook', icon: <FacebookIcon fontSize="small" />, link: getSocialLink('facebook', redes?.facebook) },
    { id: 'tiktok', nombre: 'TikTok', icon: <TikTokIcon fontSize="small" />, link: getSocialLink('tiktok', redes?.tiktok) },
    { id: 'youtube', nombre: 'YouTube', icon: <YouTubeIcon fontSize="small" />, link: getSocialLink('youtube', redes?.youtube) },
    { id: 'x', nombre: 'X', icon: <XIcon fontSize="small" />, link: getSocialLink('x', redes?.x) },
    { id: 'linkedin', nombre: 'LinkedIn', icon: <LinkedInIcon fontSize="small" />, link: getSocialLink('linkedin', redes?.linkedin) }
  ].filter(social => social.link);

  return (
    <Box
      sx={{
        width: '100%',
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: { xs: 2, md: 4 },
        py: 2,
        px: { xs: 2, sm: 0 },
        color: 'text.secondary'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocalOfferIcon sx={{ color: 'primary.main', fontSize: 20 }} />
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {categories || "Servicios"}
        </Typography>
      </Box>

      {socialIcons.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: { sm: 'auto' } }}>
          {socialIcons.map((social) => (
            <Box
              key={social.id}
              component="a"
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.nombre}
              sx={{
                color: 'primary.main',
                transition: 'all 0.2s',
                '&:hover': { opacity: 0.7, transform: 'translateY(-2px)' },
                display: 'flex'
              }}
            >
              {social.icon}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PageInfoBar;
